import React, { useLayoutEffect, useState, forwardRef } from 'react';
import { FormLabel } from '../form-label';
import { FormHelperText } from '../form-helper-text';
import { Wrap, ChipWrap, Input, SuggestWrap, Suggest, StyledChip } from './styled';
import { getFirstErrorMessage } from '../../validators/utils';
import { Divider } from '../divider';
const getHintMessage = (validateResult, hints) => {
    const { persistentHint, errorHint } = hints;
    if (!validateResult.isValid)
        return errorHint || getFirstErrorMessage(validateResult);
    return persistentHint;
};
export const ChipInput = forwardRef(function ChipInput({ label, labelTooltip, ariaLabel, persistentHint, suggests = [], sizeComponent = 'medium', disabled, errorHint, onChange, validator, addChipOnBlur = true, fixedPadding, required, CustomHelperText, ...props }, ref) {
    const [currentChip, setCurrentChip] = useState('');
    const [chips, setChips] = useState(props.chips || []);
    const [validateResult, setValidateResult] = useState({
        isValid: true,
        messages: []
    });
    useLayoutEffect(() => {
        var _a;
        setChips((_a = props.chips) !== null && _a !== void 0 ? _a : []);
    }, [props.chips]);
    const handleChangeChip = (event) => {
        const { target: { value } } = event;
        if (validator) {
            const result = validator(value);
            setValidateResult(result);
        }
        setCurrentChip(value);
    };
    const handleAddChip = (value) => {
        const newChip = {
            value,
            id: `${value}-${chips.length}`,
            isEditable: true
        };
        if (value) {
            setChips([...chips, newChip]);
            onChange([...chips, newChip]);
        }
    };
    const handleBlurChip = () => {
        if (addChipOnBlur && validateResult.isValid) {
            handleAddChip(currentChip);
            setCurrentChip('');
        }
    };
    const handleKeyDownChip = (event) => {
        if (event.key === 'Enter' && validateResult.isValid) {
            handleAddChip(currentChip);
            setCurrentChip('');
            event.stopPropagation();
            event.preventDefault();
        }
        if (event.key === 'Backspace' && !currentChip && chips.length) {
            const lastChip = chips[chips.length - 1];
            const newChips = lastChip.isEditable
                ? chips.filter((chip) => chip.id !== lastChip.id)
                : chips;
            setChips(newChips);
            onChange(newChips);
        }
    };
    const handeRemoveChip = (event) => {
        if (!disabled) {
            const chipId = event.currentTarget.getAttribute('data-chip-id');
            const newChips = chips.filter((item) => item.id !== chipId);
            setChips(newChips);
            onChange(newChips);
        }
    };
    const handleSelectSuggest = (event) => {
        const suggest = event.currentTarget.getAttribute('data-value');
        handleAddChip(suggest);
    };
    const renderChips = () => {
        return chips.map((item) => {
            return (React.createElement(StyledChip, { id: item.id, type: "chipInput", variant: "default", key: item.id, disabled: disabled, isStatic: !item.isEditable, onRemove: handeRemoveChip, title: item.value }));
        });
    };
    const renderSuggests = () => {
        return suggests.map((suggest, index) => (React.createElement(Suggest, { key: `${suggest}-${index}`, "data-value": suggest, onClick: handleSelectSuggest }, suggest)));
    };
    return (React.createElement(React.Fragment, null,
        label && (React.createElement(FormLabel, { labelTooltip: labelTooltip, required: required }, label)),
        React.createElement(Wrap, { disabled: disabled },
            React.createElement(ChipWrap, null,
                renderChips(),
                React.createElement(Input, { disabled: disabled, required: required, ref: ref, value: currentChip, "aria-label": ariaLabel, onBlur: handleBlurChip, onKeyDown: handleKeyDownChip, onChange: handleChangeChip, sizeComponent: sizeComponent, isValid: validateResult.isValid, "aria-invalid": !validateResult.isValid, ...props })),
            !disabled && suggests.length !== 0 && (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement(SuggestWrap, null, renderSuggests())))), CustomHelperText !== null && CustomHelperText !== void 0 ? CustomHelperText : (React.createElement(FormHelperText, { fixedPadding: fixedPadding, msgType: !validateResult.isValid ? 'error' : undefined }, getHintMessage(validateResult, { persistentHint, errorHint })))));
});
